import React from 'react'

const AppFooter = (props) => {
  return <div className='layout-footer'></div>
}

export default AppFooter
